import React from 'react'

export default function Welcome() {
  return (
    <>
        <h1><strong>Welcome to HandyNoteBook,</strong> Login/Signup to add Notes</h1>
    </>
  )
}
